import React from 'react'
import ProductAvailble from '@/components/Product/ProductAvailble'
import ProductAvaibleAfter from '@/components/Product/ProductAvaibleAfter'
import PromotionPastille from '@/components/Product/PromotionPastille'
import InformationPeremption from './InformationPeremption'
import { Product } from '@/src/types/api-types'
import COLORS from '@/src/colors'
import Card from '../Common/Card'

type Props = {
  product: Product
  isPromotion?: boolean
  promotionLimited?: any
}

const ProductInformationBlock: React.FC<Props> = ({
  product,
  isPromotion = false,
  promotionLimited = null,
}) => {
  const isPrecommande = product.precommande === 'Y'

  return (
    <Card className="w-fit">
      <div className="space-y-4" style={{ margin: 'auto', color: COLORS.grayText }}>
        <ProductAvailble product={product} displayDateAvailable={true} className="!justify-start" />
        {/* Sur un produit precommande la date est deja portee par <PrecommandeInfo> dans ProductResume.
            On masque ici pour eviter le double affichage. */}
        {!isPrecommande && (
          <ProductAvaibleAfter
            product={product}
            displayDateAvailable={true}
            className="!justify-start"
          />
        )}
        {(isPromotion || promotionLimited) && (
          <PromotionPastille promotionLimited={promotionLimited} className="!justify-start" />
        )}
        <InformationPeremption product={product} className="!justify-start" />
      </div>
    </Card>
  )
}

export default ProductInformationBlock
